var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.69328C6 6.00887 5.74416 6.26471 5.42857 6.26471L4.57143 6.26471C4.25584 6.26471 4 6.00887 4 5.69328L4 0.920171C4 0.60458 4.25584 0.348742 4.57143 0.348742L5.42857 0.348742C5.74416 0.348742 6 0.60458 6 0.920172L6 5.69328Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.92857C6 9.24416 5.74416 9.5 5.42857 9.5L4.57143 9.5C4.25584 9.5 4 9.24416 4 8.92857L4 7.92017C4 7.60458 4.25584 7.34874 4.57143 7.34874L5.42857 7.34874C5.74416 7.34874 6 7.60458 6 7.92017L6 8.92857Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnIcon);
export default __webpack_public_path__ + "static/media/WarnIcon.da33c907b41ff8a69fcfa434a7a0f6ed.svg";
export { ForwardRef as ReactComponent };